var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { reaction, makeObservable } from 'mobx';
import React from 'react';
import { computed } from 'mobx';
import { observer, disposeOnUnmount } from 'mobx-react';
import 'antd/es/style/index.less';
import { Actor_ } from '../actor/Actor_';
import { runtime } from '../../classes/runtime/Runtime';
import { AppStage } from './AppStage';
import { xa } from '../../utils/xa/xa';
import { GlobalComponents_ } from './GlobalComponents_';
let TopicAppContainer_ = class TopicAppContainer_ extends React.PureComponent {
    someReactionDisposer = reaction(() => this.props.app.user.plainUserData, (value, reaction) => {
        xa.user.saveUser(value);
    }, { delay: 200, fireImmediately: false });
    constructor(props) {
        super(props);
        makeObservable(this);
    }
    render() {
        const { app } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement(GlobalComponents_, { app: app }),
            React.createElement(Actor_, { actor: app, structureTemplate: React.createElement("div", { "data-aspect": "inner", style: { flex: '1 1 auto', display: 'flex', flexDirection: 'column', alignItems: 'stretch' } },
                    React.createElement(AppStage, { app: app }),
                    this.multiPlayerBoard) })));
    }
    get multiPlayerBoard() {
        if (!this.props.app.menubarRight.isMultiPlayerMode)
            return null;
        const { MultiBoard_ } = runtime.solidPackages.Multi.components;
        return React.createElement(MultiBoard_, { app: this.props.app });
    }
};
__decorate([
    disposeOnUnmount
], TopicAppContainer_.prototype, "someReactionDisposer", void 0);
__decorate([
    computed
], TopicAppContainer_.prototype, "multiPlayerBoard", null);
TopicAppContainer_ = __decorate([
    observer
], TopicAppContainer_);
export { TopicAppContainer_ };
